import Grid from '@material-ui/core/Grid';
import TextField from '@mui/material/TextField';
import { Autocomplete } from '@mui/material';
import { useEffect, useState, memo } from 'react';

const SangerRowType = memo((props) => {
    const data = props.data;
    const updateSample = props.updateSample;
    const templateOptions = props.templateOptions;
    const updateTemplateOptions = props.updateTemplateOptions;
    const submitShowError = props.submitShowError;
    const typeOptions = ['DNA', 'Plasmid-insert', 'Plasmid'];

    const handleChange = (newData, id) => {
        if (newData.type != null) {
          if (newData.type === "Plasmid" && (data.type === "DNA" || data.type === "Plasmid-insert")) {
            newData.template = ''
          }
          if ((newData.type === "DNA" || newData.type === "Plasmid-insert") && (data.type === "Plasmid")) {
            newData.template = ''
          } 
        }
        // const tempData = { ...data, ...newData };
        console.log(newData);
        updateSample(newData, id);
      };
  
  return (
    <Grid>
    <Grid item alignItems="stretch" style={{ display: 'flex', width: 140 }}>
    <Autocomplete
            disablePortal
            disableClearable={true}
            isOptionEqualToValue={(option, value) => option.value === value.value}
            id="type"
            variant="outlined"
            options={typeOptions}
            value={data.type}
            onBlur={(e) => {
              var newTouched = [...data.touched];
              newTouched[5] = true;
              handleChange({ touched: newTouched }, props.id);
            }}
            onChange={async (e, currData) => {
              var newTouched = [...data.touched];
              newTouched[5] = true;
              handleChange({ type: currData, touched: newTouched }, props.id)
              updateTemplateOptions(currData, templateOptions)
            }}
            sx={{ width: 150, '& .MuiInputBase-root': { height: 40, borderRadius: 0 }, '& legend': { display: 'none' },
            '& fieldset': { top: 0 }, }}
            renderInput={(params) => 
              <TextField 
                {...params} 
                placeholder="Type"
                inputProps={{
                  ...params.inputProps,
                  readOnly: true,
                  style : {marginTop: -5, marginLeft: -10, marginRight: -10}
                }}
                error={((data.touched[5] || submitShowError)) && (data.type == undefined || data.type == '')}
              />}
      />
    </Grid>
    </Grid>
    );
},
(prevProps, nextProps) => {
    return prevProps.id === nextProps.id && prevProps.data.type === nextProps.data.type;
});

export default SangerRowType;